import "./App.css";
import { useState } from "react";

import BuilderForm from "./components/Builder/BuilderForm";
import Output from "./components/Output/Output";

import Grid from "@mui/material/Grid";

const App = () => {
  const [output, setOutput] = useState("");

  // Lift the state from the BuilderForm and send it over
  //  to the Output component
  const getOutput = (tbl: string) => {
    setOutput(tbl);
  };

  return (
    <div>
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <BuilderForm onGeneration={getOutput} />
        <Output value={output} />
      </Grid>
    </div>
  );
};

export default App;
